<script lang="ts" setup>
const meta = inject('meta', ref())
const { strapiData, strapiError, getStrapiData } = useStrapiCms(meta?.value?.strapi_id, undefined, undefined, 'page', meta.value?.strapi_locale || '')
const { $t } = useI18n()

await getStrapiData()

const pageTitle = computed(
  () => strapiData.value?.PageTitle || '',
)

const metaTitle = computed(
  () => strapiData.value?.MetaData?.MetaTitle || pageTitle.value + ' | ' + $t('meta.title'),
)

const metaDescription = computed(
  () => strapiData.value?.MetaData?.MetaDescription || $t('meta.description'),
)

const { setBreadcrumbs } = useBreadcrumbs()
setBreadcrumbs({
  label: pageTitle.value,
  parents: meta.value?.parents,
})

const { pageView } = useDataLayer()

if (meta.value?.label === '404') {
  pageView('404', metaTitle.value)
}
else {
  pageView('cms', metaTitle.value)
}

useHead({
  title: metaTitle,
  meta: [
    { name: 'description', content: metaDescription },
    { name: 'robots', content: strapiData.value?.MetaData?.MetaRobots?.replace('_', ', ') },
  ],
  script: [
    { type: 'application/ld+json', key: 'RichSnippets', innerHTML: strapiData.value?.MetaData?.RichSnippets || '' },
  ],
})

const route = useRoute()
const { canonical } = useSeo()
canonical(computed(() => route.path))
</script>

<template>
  <div>
    <div
      v-if="strapiData"
      class="cms-page"
    >
      <!-- Disabled for home -->
      <AppBreadcrumbs v-if="$route.path !== '/'" />

      <UiHeading class="cms-page__heading">
        {{ pageTitle }}
      </UiHeading>

      <UiHeadingSection>
        <StrapiSlices
          v-if="strapiData?.Slices?.length"
          :slices="strapiData.Slices"
        />
      </UiHeadingSection>

      <!--  -->
      <!--  -->
    </div>

    <slot />

    
  </div>
</template>

<style>
@import url("~layers/pages/~cms.css");
</style>
